import { useCastSender } from '../lib/useCastSender'
import type { Session } from '../lib/api'

type Props = { session: Session | null }

export function CastPanel({ session }: Props) {
  const { phase, deviceName, volume, error, playerState, lastStop, cast, stop, setVolume } = useCastSender()
  const ready = session?.status === 'ready'
  // Casting now would hand the TV the copy it cannot start; wait for the
  // GPU rendition, which takes a few seconds once the check decides it.
  const preparing = session?.tv === 'checking' || session?.tv === 'starting'

  return (
    <section className="panel">
      <header className="panel__header">
        <h2>Chromecast</h2>
        {deviceName && <span className="cast__device">{deviceName}</span>}
      </header>

      {phase === 'loading' && <p className="panel__hint">Cercant dispositius…</p>}

      {phase === 'unsupported' && (
        <p className="panel__hint">
          Aquest navegador no pot emetre. Cal Chrome (Android, Windows, macOS, Linux o ChromeOS);
          a l'iPhone i l'iPad no hi ha Cast des del navegador.
        </p>
      )}

      {phase === 'no-devices' && (
        <p className="panel__hint">Cap dispositiu en aquesta xarxa.</p>
      )}

      {(phase === 'ready' || phase === 'connecting' || phase === 'connected') && (
        <>
          <div className="panel__actions">
            <button
              className="btn btn--primary"
              disabled={!ready || preparing || phase === 'connecting'}
              onClick={() => session && void cast(session.castUrl, session.link)}
            >
              {preparing ? 'Preparant per a la tele…' : phase === 'connected' ? 'Emet aquest canal' : 'Tria un dispositiu i emet'}
            </button>
            {phase === 'connected' && (
              <button className="btn" onClick={() => void stop()}>
                Atura l'emissió
              </button>
            )}
          </div>

          {phase === 'connected' && (
            <label className="volume">
              <span>Volum</span>
              <input
                type="range"
                min={0}
                max={1}
                step={0.05}
                value={volume ?? 0}
                disabled={volume === null}
                onChange={(e) => setVolume(Number(e.target.value))}
              />
              <span className="volume__value">
                {volume === null ? '—' : `${Math.round(volume * 100)}%`}
              </span>
            </label>
          )}

          {!ready && <p className="panel__hint">Obre un canal abans d'emetre'l.</p>}
        </>
      )}

      {ready && session && (
        <p className="panel__hint">
          El dispositiu rebrà <code>{session.castUrl.replace(/\?t=.*/, '')}</code> amb un testimoni
          d'accés temporal.
        </p>
      )}

      {playerState && phase === 'connected' && (
        <p className="panel__hint">
          Estat del receptor: <strong>{playerState}</strong>
        </p>
      )}
      {lastStop && <p className="panel__error">{lastStop}</p>}
      {error && <p className="panel__error">{error}</p>}
    </section>
  )
}
